export const ORDER_RESOURCES = [
  {
    id: 'beba3',
    title: 'Bloody Easy Blood Administration Version 3 Handbook',
  },
  {
    id: 'be51',
    title:
      'Bloody Easy 5.1: Blood Transfusions, Blood Alternatives and Transfusion Reactions. A Guide to Transfusion Medicine, Fifth Edition Handbook',
  },
  {
    id: 'coag',
    title: 'Bloody Easy Coagulation Simplified, Second Edition Handbook',
  },
  {
    id: 'bebaFr',
    title: 'Sang difficulté l’administration du sang version 3',
  },
] as const;

export type OrderResourceId = (typeof ORDER_RESOURCES)[number]['id'];

export const ORDER_INSTITUTE_TYPES = [
  'Ontario Small Hospital',
  'Ontario Community Hospital',
  'Ontario Teaching Hospital',
  'Education Facility',
] as const;

export const ORDER_PROVINCES = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
] as const;

export const ORDER_QUANTITY_MAX = 999;

export const ORDER_QUANTITY_HINT =
  'Please list the quantity (in numbers) under each resource you would like to order.';

export const ORDER_ORGANIZATION_HINT =
  "Please enter the complete name without abbreviations (e.g., avoid 'Intl.' for 'International'), except for standard terms like 'Inc.' or 'Ltd.'.";

export const ORDER_OUTSIDE_ONTARIO_NOTE =
  'Note: there is a fee that needs to be prepaid for orders outside of Ontario (Canada) as follows: BE5 $20, BEBA3 $10, BE Coag $10 plus Shipping & Handling';
